import { Injectable } from '@angular/core';
import { FilterModel } from '@ui/shared/util-filter';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { FilterState } from './filter-state.service';

/**
 * A basic implementation of the AbstractActiveFilterService.
 * This service implements only a simple input and output of filters, enough for most maps.
 *
 * Some maps may need to implement their own ActiveFilterService
 * in order to change interdependent filters when other filters change.
 */
@Injectable()
export class SimpleActiveFilterService extends FilterState {

    public readonly activeFilters$ = new BehaviorSubject<Map<string, FilterModel>>(new Map());

    public closeAllOverlays$: Observable<void>;

    private readonly _closeAllOverlays$ = new Subject<void>();

    constructor() {
        super();

        this.closeAllOverlays$ = this._closeAllOverlays$.asObservable();
    }

    public setActiveFilter(filter: FilterModel): void {
        const activeFilters = new Map(this.activeFilters$.getValue());

            if (filter.values.length) {
                activeFilters.set(filter.key, filter);
            } else {
                // If a filter is set without values, it is removed from the active filters map.
                activeFilters.delete(filter.key);
            }

        this.activeFilters$.next(activeFilters);
    }

    public resetActiveFilters(): void {
        this.activeFilters$.next(new Map());
    }

    public closeAllOverlays(): void {
        this._closeAllOverlays$.next();
    }

}
